import { Button } from "@mantine/core";
import { modals } from "@mantine/modals";
import type { JSX } from "react";
import { useRef } from "react";
import ImprovementModal from "./ImprovementModal";
import type { ThreadSuggestionData } from "./types";

interface IProps {
    currentInstructions: string;
    threads: ThreadSuggestionData[];
    onApplied: (newPrompt: string) => void;
}

function SuggestImprovement({ currentInstructions, threads, onApplied }: IProps): JSX.Element {
    const modalIdRef = useRef<string | null>(null);

    const hasAnyJudgements = threads.some((t) => t.llmJudgeScore !== undefined && t.llmJudgeScore !== null);

    const open = () => {
        const id = modals.open({
            title: "AI suggest improvement",
            size: 1000,
            children: (
                <ImprovementModal
                    hasAnyJudgements={hasAnyJudgements}
                    currentInstructions={currentInstructions}
                    threads={threads}
                    onApplied={onApplied}
                    onClose={() => {
                        if (modalIdRef.current) {
                            modals.close(modalIdRef.current);
                            modalIdRef.current = null;
                        }
                    }}
                />
            ),
        });
        modalIdRef.current = id;
    };

    return <Button onClick={open}>Suggest improvement (AI)</Button>;
}

export default SuggestImprovement;
